import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
import focusElement from '~/helpers/a11y-helpers';
export default {
  name: 'SkipTo',
  props: {
    text: {
      type: String,
      default: ''
    },
    to: {
      type: String,
      default: ''
    },
    tabindex: {
      type: [Number, null],
      default: null
    }
  },
  methods: {
    skipPressed: function skipPressed() {
      focusElement(this.$el.hash);
    }
  }
};